export default __webpack_public_path__ + "static/media/tool-field-outdoor-full.0b8d9e8f.svg";